import React from 'react';
import axios from '../api/axios';
import Precios from './Precios';
import Superficies from './Superficies';
import { IconCancelCircle } from '../icons/icons';
import './webscrapping.scss';



const WebScrapping = () => {

  const [fotoCasaForm, setFotoCasaForm] = React.useState(
    {
      localizacion: '',
      transaccion: '',
      tipoInmueble: '',
      segundaMano: false,
      obraNueva: false,
      precioMin: '',
      precioMax: '',
      plantasIntermedias: false,
      apartamentos: false,
      atico: false,
      duplex: false,
      loft: false,
      plantaBaja: false,
      estudio: false,
      casaChalet: false,
      fincaRustica: false,
      casaAdosada: false,
      localComercial: false,
      naveIndustrial: false,
      habitaciones: '',
      baños: '',
      superficieMin: '',
      superficieMax: ''
    }
  );


  const fotoCasaFormHandle = (e) => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFotoCasaForm({
      ...fotoCasaForm,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchURL = '/users';
    let id = localStorage.getItem('id');
    let formDataToPatch = { fotoCasaForm };
    console.log('fotoCasaForm: ', fotoCasaForm);
    let axiosConfig = {
      headers: { 'Content-Type': 'application/json' },
      withCredentials: true
    }

    await axios
      .patch(
        `${patchURL}/${id}`,
        formDataToPatch,
        axiosConfig
      )
      .then((response) => {
        let fotoCasaForm = response.data;
        localStorage.setItem('fotoCasaForm', JSON.stringify(fotoCasaForm));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  return (
    <div className='modal-container-overlay'>
      <div className='fotocasa-form-box'>
        <div className='fotocasa-form-header'>
          <h3>Filtros</h3>
          <button>
            <i><IconCancelCircle /></i>
          </button>
        </div>
        <form
          className='fotocasa-form'
          onSubmit={handleSubmit}
        >
          <div className='form-content-out'>
            <div className='form-content-in'>
              <div className='container-main'>
                <div className='input-large'>
                  <label htmlFor='localizacion'>
                    <h5>¿Dónde buscas?</h5>
                  </label>
                  <select
                    type='text'
                    id='localizacion'
                    name='localizacion'
                    required
                    value={fotoCasaForm.localizacion}
                    onChange={fotoCasaFormHandle}
                  >
                    <option value='Nueva España'>Nueva España</option>
                    <option value='Arganzuela'>Arganzuela</option>
                    <option value='Barajas'>Barajas</option>
                    <option value='Salamanca'>Salamanca</option>
                    <option value='Centro'>Centro</option>
                  </select>
                </div>
              </div>
              <div className='container-main'>
                <div className='container-row'>
                  <div className='input-short'>
                    <label htmlFor='transaccion'>
                      <h5>Transacción</h5>
                    </label>
                    <select
                      type='text'
                      id='transaccion'
                      name='transaccion'
                      required
                      value={fotoCasaForm.transaccion}
                      onChange={fotoCasaFormHandle}
                    >
                      <option value='comprar'>Comprar</option>
                      <option value='alquilar'>Alquilar</option>
                      <option value='compartir'>Compartir</option>
                      <option value='alquiler-opcion-compra'>Alquiler con opcion a comp...</option>
                      <option value='traspaso'>Traspaso</option>
                    </select>
                  </div>
                  <div className='input-short'>
                    <label htmlFor='tipoInmueble'>
                      <h5>Tipos de inmueble</h5>
                    </label>
                    <select
                      type='text'
                      id='tipoInmueble'
                      name='tipoInmueble'
                      required
                      value={fotoCasaForm.tipoInmueble}
                      onChange={fotoCasaFormHandle}
                    >
                      {
                        fotoCasaForm.transaccion === 'compartir'
                          ? <option value='vivienda'>Vivienda</option>
                          : fotoCasaForm.transaccion === 'alquiler-opcion-compra'
                            ? <option value='vivienda'>Vivienda</option>
                            : fotoCasaForm.transaccion === 'traspaso'
                              ? <option value='local-nave'>Local y nave</option>
                              :
                              <>
                                <option value='vivienda'>Vivienda</option>
                                <option value='local-nave'>Local y nave</option>
                                <option value='garaje'>Garaje</option>
                                <option value='oficina'>Oficina</option>
                                <option value='trastero'>Trastero</option>
                                <option value='terreno'>Terreno</option>
                                <option value='edificio'>Edificio</option>
                              </>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <div
                className={
                  fotoCasaForm.transaccion === 'compartir'
                    ? 'hidden-container'
                    : fotoCasaForm.transaccion === 'traspaso'
                      ? 'hidden-container'
                      : fotoCasaForm.transaccion === 'alquiler-opcion-compra'
                        ? 'container-main'
                        : fotoCasaForm.tipoInmueble === 'vivienda'
                          ? 'container-main'
                          : 'hidden-container'
                }
              >
                <div className='input-title'>
                  <h5>Tipo de construcción</h5>
                </div>
                <div className='container-row'>
                  <div className='checkbox-container'>
                    <div className='input-checkbox'>
                      <label htmlFor='segundaMano'>
                        <input
                          type='checkbox'
                          id='segundaMano'
                          name='segundaMano'
                          value={fotoCasaForm.segundaMano}
                          onChange={fotoCasaFormHandle}
                        />
                        <h6>Segunda mano</h6>
                      </label>
                    </div>
                  </div>
                  <div className='checkbox-container'>
                    <div className='input-checkbox'>
                      <label htmlFor='obraNueva'>
                        <input
                          type='checkbox'
                          id='obraNueva'
                          name='obraNueva'
                          value={fotoCasaForm.obraNueva}
                          onChange={fotoCasaFormHandle}
                        />
                        <h6>Obra nueva</h6>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  fotoCasaForm.transaccion === 'alquilar'
                    ?
                    fotoCasaForm.tipoInmueble === 'terreno'
                      ? 'hidden-container'
                      : 'container-main'
                    : 'container-main'
                }
              >
                <div className='input-title'>
                  <h5>Precio</h5>
                </div>
                <div className='container-row'>
                  <div className='input-short'>
                    <label htmlFor='precioMin'>
                      <h5>Minimo</h5>
                    </label>
                    <select
                      type='text'
                      id='precioMin'
                      name='precioMin'
                      required
                      value={fotoCasaForm.precioMin}
                      onChange={fotoCasaFormHandle}
                    >
                      <Precios
                        fotoCasaForm={fotoCasaForm}
                      />
                    </select>
                  </div>
                  <div className='input-short'>
                    <label htmlFor='precioMax'>
                      <h5>Máximo</h5>
                    </label>
                    <select
                      type='text'
                      id='precioMax'
                      name='precioMax'
                      required
                      value={fotoCasaForm.precioMax}
                      onChange={fotoCasaFormHandle}
                    >
                      <Precios
                        fotoCasaForm={fotoCasaForm}
                      />
                    </select>
                  </div>
                </div>
              </div>
              <div
                className={
                  fotoCasaForm.transaccion === 'comprar'
                    ?
                    fotoCasaForm.tipoInmueble === 'vivienda'
                      ? 'container-main'
                      : fotoCasaForm.tipoInmueble === 'local-nave'
                        ? 'container-main'
                        : 'hidden-container'
                    :
                    fotoCasaForm.transaccion === 'alquilar'
                      ?
                      fotoCasaForm.tipoInmueble === 'vivienda'
                        ? 'container-main'
                        : fotoCasaForm.tipoInmueble === 'local-nave'
                          ? 'container-main'
                          : 'hidden-container'
                      :
                      fotoCasaForm.transaccion === 'compartir'
                        ? 'container-main'
                        :
                        fotoCasaForm.transaccion === 'alquiler-opcion-compra'
                          ? 'container-main'
                          :
                          fotoCasaForm.transaccion === 'traspaso'
                            ? 'container-main'
                            : 'hidden-container'
                }
              >
                <div className='input-title'>
                  <h5>Tipo de vivienda</h5>
                </div>
                {
                  fotoCasaForm.transaccion === 'traspaso' ?
                    <>
                      <div className='container-row'>
                        <div className='checkbox-container'>
                          <div className='input-checkbox'>
                            <label htmlFor='localComercial'>
                              <input
                                type='checkbox'
                                id='localComercial'
                                name='localComercial'
                                value={fotoCasaForm.localComercial}
                                onChange={fotoCasaFormHandle}
                              />
                              <h6>Local comercial</h6>
                            </label>
                          </div>
                          <div className='input-checkbox'>
                            <label htmlFor='naveIndustrial'>
                              <input
                                type='checkbox'
                                id='naveIndustrial'
                                name='naveIndustrial'
                                value={fotoCasaForm.naveIndustrial}
                                onChange={fotoCasaFormHandle}
                              />
                              <h6>Nave industrial</h6>
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                    :
                    fotoCasaForm.tipoInmueble === 'local-nave' ?
                      <>
                        <div className='container-row'>
                          <div className='checkbox-container'>
                            <div className='input-checkbox'>
                              <label htmlFor='localComercial'>
                                <input
                                  type='checkbox'
                                  id='localComercial'
                                  name='localComercial'
                                  value={fotoCasaForm.localComercial}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Local comercial</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label htmlFor='naveIndustrial'>
                                <input
                                  type='checkbox'
                                  id='naveIndustrial'
                                  name='naveIndustrial'
                                  value={fotoCasaForm.naveIndustrial}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Nave industrial</h6>
                              </label>
                            </div>
                          </div>
                        </div>
                      </>
                      :
                      <>
                        <div className='container-row'>
                          <div className='checkbox-container'>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='plantasIntermedias'>
                                <input
                                  type='checkbox'
                                  id='plantasIntermedias'
                                  name='plantasIntermedias'
                                  value={fotoCasaForm.plantasIntermedias}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Plantas Intermedias</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='apartamentos'>
                                <input
                                  type='checkbox'
                                  id='apartamentos'
                                  name='apartamentos'
                                  value={fotoCasaForm.apartamentos}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Apartamento</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='atico'>
                                <input
                                  type='checkbox'
                                  id='atico'
                                  name='atico'
                                  value={fotoCasaForm.atico}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Ático</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='duplex'>
                                <input
                                  type='checkbox'
                                  id='duplex'
                                  name='duplex'
                                  value={fotoCasaForm.duplex}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Dúplex</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='loft'>
                                <input
                                  type='checkbox'
                                  id='loft'
                                  name='loft'
                                  value={fotoCasaForm.loft}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Loft</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='plantaBaja'>
                                <input
                                  type='checkbox'
                                  id='plantaBaja'
                                  name='plantaBaja'
                                  value={fotoCasaForm.plantaBaja}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Planta baja</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label
                                htmlFor='estudio'>
                                <input
                                  type='checkbox'
                                  id='estudio'
                                  name='estudio'
                                  value={fotoCasaForm.estudio}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Estudio</h6>
                              </label>
                            </div>
                          </div>
                          <div className='checkbox-container'>
                            <div className='input-checkbox'>
                              <label htmlFor='casaChalet'>
                                <input
                                  type='checkbox'
                                  id='casaChalet'
                                  name='casaChalet'
                                  value={fotoCasaForm.casaChalet}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Casa o chalet</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label htmlFor='fincaRustica'>
                                <input
                                  type='checkbox'
                                  id='fincaRustica'
                                  name='fincaRustica'
                                  value={fotoCasaForm.fincaRustica}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Finca rústica</h6>
                              </label>
                            </div>
                            <div className='input-checkbox'>
                              <label htmlFor='casaAdosada'>
                                <input
                                  type='checkbox'
                                  id='casaAdosada'
                                  name='casaAdosada'
                                  value={fotoCasaForm.casaAdosada}
                                  onChange={fotoCasaFormHandle}
                                />
                                <h6>Casa adosada</h6>
                              </label>
                            </div>
                          </div>
                        </div>
                      </>

                }
              </div>
              <div
                className={
                  fotoCasaForm.transaccion === 'comprar'
                    ? fotoCasaForm.tipoInmueble === 'vivienda'
                      ? 'container-main'
                      : 'hidden-container'
                    : fotoCasaForm.transaccion === 'alquilar'
                      ? fotoCasaForm.tipoInmueble === 'vivienda'
                        ? 'container-main'
                        : 'hidden-container'
                      : fotoCasaForm.transaccion === 'compartir'
                        ? 'container-main'
                        : fotoCasaForm.transaccion === 'alquiler-opcion-compra'
                          ? 'container-main'
                          : 'hidden-container'
                }
              >
                <div className='container-row'>
                  <div className='input-short'>
                    <label htmlFor='habitaciones'>
                      <h5>Habitaciones</h5>
                    </label>
                    <select
                      type='text'
                      id='habitaciones'
                      name='habitaciones'
                      required
                      value={fotoCasaForm.habitaciones}
                      onChange={fotoCasaFormHandle}
                    >
                      <option value='todo' defaultValue>Todo</option>
                      <option value='1+'>1+</option>
                      <option value='2+'>2+</option>
                      <option value='3+'>3+</option>
                      <option value='4+'>4+</option>
                    </select>
                  </div>
                  <div className='input-short'>
                    <label htmlFor='baños'>
                      <h5>Baños</h5>
                    </label>
                    <select
                      type='text'
                      id='baños'
                      name='baños'
                      required
                      value={fotoCasaForm.baños}
                      onChange={fotoCasaFormHandle}
                    >
                      <option value='todo' defaultValue>Todo</option>
                      <option value='1+'>1+</option>
                      <option value='2+'>2+</option>
                      <option value='3+'>3+</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='container-main'>
                <div className='input-title'>
                  <h5>Superficie</h5>
                </div>
                <div className='container-row'>
                  <div className='input-short'>
                    <label htmlFor='superficieMin'>
                      <h5>Minimo</h5>
                    </label>
                    <select
                      type='text'
                      id='superficieMin'
                      name='superficieMin'
                      required
                      value={fotoCasaForm.superficieMin}
                      onChange={fotoCasaFormHandle}
                    >
                      <Superficies
                        fotoCasaForm={fotoCasaForm}
                      />
                    </select>
                  </div>
                  <div className='input-short'>
                    <label htmlFor='superficieMax'>
                      <h5>Máximo</h5>
                    </label>
                    <select
                      type='text'
                      id='superficieMax'
                      name='superficieMax'
                      required
                      value={fotoCasaForm.superficieMax}
                      onChange={fotoCasaFormHandle}
                    >
                      <Superficies
                        fotoCasaForm={fotoCasaForm}
                      />
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='form-button'>
            <button type='submit'>
              <h4>Mostrar anuncios</h4>
            </button>
          </div>
        </form>
      </div >
    </div >
  )
}

export default WebScrapping;